import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { AdminProductContextOperationsResponse } from './admin-product-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { SalesType } from '@web/shared/module/shop';
import { AdminProductCosmeticBrandResponse } from './admin-product-cosmetic-brand.response';
import { AdminProductStatus } from '../../enums/admin-product-status';

@jsonObject
export class AdminProductCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly type!: SalesType;

  @jsonMember(Number)
  public readonly price?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly status!: AdminProductStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminProductCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminProductCosmeticBrandResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminProductContextOperationsResponse)
  public readonly contextOperations!: AdminProductContextOperationsResponse;
}
